<template>
  <el-card>
    <div slot="header" class="clearfix">
      <el-col :lg="8">
        <el-link icon="el-icon-back" @click="$router.push({ name: 'integration' })"></el-link>
        {{ $t("integracao-logs") }}
        <small>({{ total }} registros)</small>
      </el-col>
      <el-col :offset="8" :lg="8">
        <el-pagination class="right" :page-size="records" background @current-change="fetchRecords"
          @size-change="changeSize" :current-page.sync="page" layout="sizes, prev, pager, next" :page-sizes="[
            50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 1000,
          ]" :total="total"></el-pagination>
      </el-col>
    </div>
    <el-card>
      <el-row type="flex">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <el-input :placeholder="$t('chave')" prefix-icon="el-icon-search" v-on:keyup.native.enter="search()"
            v-model="filter.tag"></el-input>
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
          <el-button type="info" icon="el-icon-search" @click="search()">{{ $t("pesquisar") }}</el-button>
        </el-col>
      </el-row>
    </el-card>
    <el-table :data="tableData" stripe style="width: 100%" :default-sort="{ prop: 'name', order: 'ascending' }">
      <el-table-column sortable v-if="usertype !== '2'" prop="customer" :label="$t('cliente')"></el-table-column>
      <el-table-column sortable prop="type" :label="$t('tipo')"></el-table-column>
      <el-table-column sortable prop="key" :label="$t('chave')"></el-table-column>
      <el-table-column prop="status" :label="$t('status')" sortable>
        <template slot-scope="scope">
          <el-tag :type="
            scope.row.status === 'wait'
              ? 'info'
              : scope.row.status === 'error'
                ? 'danger'
                : scope.row.status">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column sortable prop="createdAt" :label="$t('data')"></el-table-column>
      <el-table-column prop="origin" :label="$t('origem')">
        <template slot-scope="scope">
          <el-popover placement="top-start" title="Origem" trigger="hover" :content="scope.row.origin">
            <el-button size="mini" slot="reference">Detalhes</el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="result" :label="$t('resultado')">
        <template slot-scope="scope">
          <el-popover placement="top-start" title="Origem" trigger="hover" :content="scope.row.result">
            <el-button size="mini" slot="reference">Detalhes</el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="#">
        <template slot-scope="scope">
          <el-button v-if="scope.row.type === 'maisenvios' && scope.row.status === 'error'"
            @click="correct(scope.row.id, scope.row.origin, scope.row.result)" size="mini"
            type="info">Corrigir</el-button>
        </template>
      </el-table-column>
    </el-table>
    <IntegrationCorrectMaisEnvios ref="correctMaisenvios" @update="update" />
  </el-card>
</template>
<script>
import { IntegrationService } from "@/services/customers/integration.services";
import { UserService } from "@/services/users/user.services";
import IntegrationCorrectMaisEnvios from "./IntegrationCorrectMaisEnvios.vue";

export default {
  name: "IntegrationLogs",
  methods: {
    correct(id, data, result) {
      const error = JSON.parse(result);
      this.$refs.correctMaisenvios.open(data, error.message, id)
    },
    update(id) {
      const vm = this;
      const index = vm.tableData.findIndex(x => x.id === id);
      vm.tableData[index].status = 'success';
      IntegrationService.status(id);
    },
    changeSize(size) {
      const vm = this;
      vm.records = size;
      vm.fetchRecords();
    },
    search() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      if (!vm.filter.tag) {
        vm.fetchRecords();
      }
      else {
        IntegrationService.logsByTag(vm.id, vm.filter.tag)
          .then((response) => {
            vm.tableData = response.records;
            vm.total = response.total;
          })
          .catch((error) => {
            this.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      }
    },
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      IntegrationService.logs(vm.id, vm.records, vm.page)
        .then((response) => {
          vm.tableData = response.records;
          vm.total = response.total;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    refresh() {
      this.fetchRecords();
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.usertype = response.type;
        if (vm.$route.params.id) {
          vm.id = vm.$route.params.id;
          vm.fetchRecords();
        }
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
  data() {
    return {
      id: "",
      records: 50,
      page: 1,
      usertype: "2",
      tableData: [],
      total: 0,
      filter: {
        tag: "",
      }
    };
  },
  components: { IntegrationCorrectMaisEnvios }
};
</script>
<style>
.right {
  float: right;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}
</style>